import { empty } from '@sdk/helpers/misc/nullable';

function sanitize(value) {
  return value.toLowerCase().trim();
}

export default function search(query, valueS = []) {
  if (empty(query)) {
    return false;
  }

  if (Array.isArray(valueS)) {
    return valueS.some(value => search(query, value));
  }

  if (typeof valueS === 'string' && typeof query === 'string') {
    return sanitize(valueS).search(new RegExp(sanitize(query.replace(/\\/g, '\\\\')))) >= 0;
  }

  return valueS === query;
}
